
















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ToggleSwitch from '@/components/UiComponents/ToggleSwitch.vue';
import * as $ from 'jquery';
import { Workflow } from '../../../../store/models/workflow/workflow';
import AdvancedSearchMobile from './AdvancedSearchMobile/AdvancedSearchMobile.vue';
import SingleEnterpriseSearch from './SingleEnterpriseSearch/SingleEnterpriseSearch.vue';
import letterSearch from '../../../../store/models/Letter/letterSearch';
import store from '@/store';
import { LetterOwner } from '../../../../store/models/LetterOwner/LetterOwner';

@Component({
    components: { ToggleSwitch, AdvancedSearchMobile,SingleEnterpriseSearch }
})
export default class LetterSearchMobile extends Vue {
    searchText = '';
    showAll = true;
    showForms = false;
    showNotForms = false;
    sortOnDate = true;
    sortOnSender = false;
    sortOnTitle = false;
    isFilterActive = false;
    @Watch('searchText')
    onSearchTextChanged() {
        this.$emit('search-text-changed', this.searchText);
    }
    // onSearch(){
    //     this.$emit('search-text-changed', this.searchText);
    // }
    clearSearchText(){
        this.searchText = "";
    }
    created(){
         $('.ui.accordion').accordion();
         $('#test').accordion();
         $('#test1').accordion();
        store.state.eventHub.$on('reset-search',this.resetSetting)
    }
    resetSetting(){
        this.onToggleSwitchClick('all')
    }
    mounted() {
        $('#filter-dropdown').dropdown({ action: 'nothing' });
        $('#search-dropdown').dropdown({ action: 'nothing' });
         $('.ui.accordion').accordion();
         $('#test').accordion();
         $('#test1').accordion();


        this.months.push(...[
            { isSelected: false, name: "فروردین", id: 1 },
            { isSelected: false, name: "اردیبهشت", id: 2 },
            { isSelected: false, name: "خرداد", id: 3 },
            { isSelected: false, name: "تیر", id: 4 },
            { isSelected: false, name: "مرداد", id: 5 },
            { isSelected: false, name: "شهریور", id: 6 },
            { isSelected: false, name: "مهر", id: 7 },
            { isSelected: false, name: "آبان", id: 8 },
            { isSelected: false, name: "آذر", id: 9 },
            { isSelected: false, name: "دی", id: 10 },
            { isSelected: false, name: "بهمن", id: 11 },
            { isSelected: false, name: "اسفند", id: 12 },
        ]);

    }


    @Prop() workflows?: Workflow[];
    @Prop() counts?: any;
    @Prop() years?: number[];
    @Prop() defaultDate?: any;
    @Watch("defaultDate")
    onDefaultDateChanged(n: any, o: any) {
        if(n.month == o.month && n.year== o.year)return;
        this.monthSelected(n.month);
        this.yearSelected(n.year);

    }

    yearsArray = [] as any[];
    @Watch('years')
    onYearsChanged(newVal: number[], oldVal: number[]) {
        this.yearsArray.length = 0;
        newVal.forEach(year => {
            this.yearsArray.push({ value: year, isSelected: this.defaultDate.year === year });
        });
    }


    months: any[] = [];



    monthSelected(monthId: number) {
        //this.months.length = 0;
        this.months.forEach(month => { month.isSelected = false; });
        const selectedMonth = this.months.find(month => month.id === monthId);
        if (selectedMonth)
            selectedMonth.isSelected = true;
        this.sendDateChangedMessage();

    }

    yearSelected(val: number) {
        this.yearsArray.forEach(year => { year.isSelected = false; });
        const selectedYear = this.yearsArray.find(year => year.value === val);
        if (selectedYear)
            selectedYear.isSelected = true;
        this.sendDateChangedMessage();
    }

    sendDateChangedMessage() {
        const year = this.yearsArray.find(y => y.isSelected);
        const month = this.months.find(m => m.isSelected);
        if (month && year) {
            this.$emit('date-filter-changed', { month: month.id, year: year.value });
        }
    }

    sortModeChanged(mode: string) {
        this.sortOnDate = false;
        this.sortOnSender = false;
        this.sortOnTitle = false;
        if (mode === 'date') this.sortOnDate = true;
        if (mode === 'title') this.sortOnTitle = true;
        if (mode === 'sender') this.sortOnSender = true;
        this.$emit('sort-mode-changed', mode);
    }

    onToggleSwitchClick(mode: string) {
        if (mode === 'all') {
            this.showAll = true;
            this.showForms = false;
            this.showNotForms = false;
            this.isFilterActive = false;

        } else if (mode === 'forms') {
            if(this.showForms == true){
                this.showAll = true;
                this.showForms = false;
                this.showNotForms = false;
                this.isFilterActive = false;
            }else{
                this.showAll = false;
                this.showForms = true;
                this.showNotForms = false;
                this.isFilterActive = true;
            }
        } else if (mode === 'notForms') {
            if(this.showNotForms == true){
                this.showAll = true;
                this.showForms = false;
                this.showNotForms = false;
                this.isFilterActive = false;
            }else{
                this.showAll = false;
                this.showForms = false;
                this.showNotForms = true;
                this.isFilterActive = true;
            }
            
        }
        this.$emit('mode-changed', mode);
    }
    

    nonConjunctiveSearch(){
        if(this.searchText.trim() === '')return;
        const searchDto = {} as letterSearch;
        searchDto.allStrings = this.searchText;
        searchDto.isConjunctive = false;
        searchDto.SearchingOwner = {} as LetterOwner;
        searchDto.SearchingOwner.id = store.state.ownerId;
        searchDto.searchInLetterOwnerDashboard = {} as LetterOwner;
        searchDto.searchInLetterOwnerDashboard.id = store.state.ownerId;
        store.commit("setAdvancedSearchSettings",searchDto);
        this.$router.push({name: "SearchResultsMobile"}).catch(err=>{ console.log('')});
    }


}
